// extracted by mini-css-extract-plugin
export default {"card":"SxdB4_1v","titleIcon":"oxq9uMev","row":"_YJyq4T2","stat":"sbknRbhz","paidSection":"KQ5O4ZOf","paidTag":"Jsbj3q8e","cardRow":"brAp_KeZ","cardIcon":"n3bnpEwz"};